export const LEGAL_TYPE_FL = 'fl'
export const LEGAL_TYPE_SEMP = 'semp'

/**
 * Статусы СМЗ, в которых банк готов пробивать чек НПД: только из них выплата
 * уходит с seller_payout_kind = receipts_and_payouts (hmetal/services/bid.py).
 * Остальные semp_*-статусы — промежуточные, выплата по ним идёт как unknown.
 */
export const SEMP_RECEIPT_READY_STATUSES = [
  'ready',
  'semp_taxpayer_already_bound',
  'semp_taxpayer_already_registered',
]

/** Самозанятый, которому уже можно платить с чеком. */
export function isSempReceiptReady(seller) {
  return seller?.legal_type === LEGAL_TYPE_SEMP
    && SEMP_RECEIPT_READY_STATUSES.includes(seller?.status)
}

/** Filter for the working seller list. A SEMP cabinet may manage both types. */
export function getSellerListLegalTypeFilter(isSempCabinet) {
  return isSempCabinet ? {} : {legal_type: LEGAL_TYPE_FL}
}

/** Filters for the operation recipient picker. */
export function getOperationSellerFilters(isSempCabinet) {
  if (isSempCabinet) {
    return {
      legal_type: LEGAL_TYPE_SEMP,
      status: SEMP_RECEIPT_READY_STATUSES.join(','),
    }
  }
  return {legal_type: LEGAL_TYPE_FL}
}

/** Client-side guard in case an API response does not honor the requested type. */
export function isSellerEligibleForOperation(seller, isSempCabinet, merchantId) {
  if (isSempCabinet) {
    if (!merchantId || !seller?.merchant_id) {
      return false
    }
    return isSempReceiptReady(seller)
      && String(seller?.merchant_id) === String(merchantId)
  }
  return seller?.legal_type === LEGAL_TYPE_FL
}

/** Old create flows omit legal_type; the public default is an individual. */
export function withDefaultSellerLegalType(sellerData, defaultLegalType = LEGAL_TYPE_FL) {
  return {
    ...sellerData,
    legal_type: sellerData?.legal_type ?? defaultLegalType,
  }
}

export function filterSellersByLegalType(sellers, legalType = LEGAL_TYPE_FL) {
  if (!Array.isArray(sellers)) {
    return sellers
  }
  return sellers.filter(seller => seller?.legal_type === legalType)
}

export function canCreateOperationForSeller(seller, isSempCabinet, merchantId) {
  if (!seller) {
    return false
  }
  if (isSempCabinet) {
    return isSellerEligibleForOperation(seller, true, merchantId)
  }
  return seller?.legal_type === LEGAL_TYPE_FL
}

export function hasPayoutRequisites(requisites) {
  return Boolean(requisites?.pan || requisites?.phone)
}

/** Chip label for recipient column; null = do not show chip. */
export function getSellerRecipientChipLabel(seller) {
  if (seller?.legal_type !== LEGAL_TYPE_SEMP) {
    return null
  }
  if (isSempReceiptReady(seller)) {
    return 'самозанятый с чеком'
  }
  return 'самозанятый'
}

export function getRecipientSellerChipLabel(seller, requisites) {
  if (!hasPayoutRequisites(requisites)) {
    return null
  }
  return getSellerRecipientChipLabel(seller)
}
